
export let wordlist = {

"the open digital wine ecosystem": {
  "en": "the open digital wine ecosystem",
  "fr": "l'écosystème numérique ouvert du vin",
  "de": "das offene digitale Weinökosystem",
  "es": "el ecosistema digital abierto del vino",
  "it": "l'ecosistema digitale aperto del vino",
  "nl": "het open digitale wijnecosysteem",
  "pt": "o ecossistema digital aberto do vinho"
},

"your wines. your cellar.": {
  "en": "your wines. your cellar.",
  "fr": "vos vins. votre cave.",
  "de": "Ihre Weine. Ihr Weinkeller.",
  "es": "tus vinos. tu bodega.",
  "it": "i tuoi vini. la tua cantina.",
  "nl": "jouw wijnen. jouw wijnkelder.",
  "pt": "os seus vinhos. a sua garrafeira."
},

"Manage your personal wine collection,": {
  "en": "Manage your personal wine collection,",
  "fr": "Gérez votre collection personnelle de vins,",
  "de": "Verwalten Sie Ihre persönliche Weinsammlung,",
  "es": "Gestiona tu colección personal de vinos,",
  "it": "Gestisci la tua collezione personale di vini,",
  "nl": "Beheer je persoonlijke wijncollectie,",
  "pt": "Faça a gestão da sua coleção pessoal de vinhos,"
},

"purchases, transactions and cellar locations.": {
  "en": "purchases, transactions and cellar locations.",
  "fr": "vos achats, transactions et emplacements en cave.",
  "de": "Einkäufe, Transaktionen und Lagerplätze im Weinkeller.",
  "es": "compras, transacciones y ubicaciones en la bodega.",
  "it": "acquisti, transazioni e posizioni in cantina.",
  "nl": "aankopen, transacties en kelderlocaties.",
  "pt": "compras, transações e localizações na garrafeira."
},

"Explore WyneCellar": {
  "en": "Explore WyneCellar",
  "fr": "Découvrir WyneCellar",
  "de": "WyneCellar entdecken",
  "es": "Explorar WyneCellar",
  "it": "Esplora WyneCellar",
  "nl": "Ontdek WyneCellar",
  "pt": "Explorar WyneCellar"
},

"taste. enjoy. remember.": {
  "en": "taste. enjoy. remember.",
  "fr": "dégustez. savourez. souvenez-vous.",
  "de": "verkosten. genießen. erinnern.",
  "es": "degusta. disfruta. recuerda.",
  "it": "degusta. assapora. ricorda.",
  "nl": "proef. geniet. onthoud.",
  "pt": "prove. desfrute. recorde."
},

"Create and manage tasting notes, organise": {
  "en": "Create and manage tasting notes, organise",
  "fr": "Créez et gérez des notes de dégustation, organisez",
  "de": "Erstellen und verwalten Sie Verkostungsnotizen, organisieren Sie",
  "es": "Crea y gestiona notas de cata, organiza",
  "it": "Crea e gestisci note di degustazione, organizza",
  "nl": "Maak en beheer proefnotities, organiseer",
  "pt": "Crie e gira notas de prova, organize"
},

"tastings and explore wines with structured templates.": {
  "en": "tastings and explore wines with structured templates.",
  "fr": "des dégustations et explorez les vins grâce à des modèles structurés.",
  "de": "Verkostungen und entdecken Sie Weine mit strukturierten Vorlagen.",
  "es": "catas y explora vinos con plantillas estructuradas.",
  "it": "degustazioni ed esplora i vini con modelli strutturati.",
  "nl": "proeverijen en ontdek wijnen met gestructureerde sjablonen.",
  "pt": "provas de vinho e explore vinhos com modelos estruturados."
},

"Explore WyneTaster": {
  "en": "Explore WyneTaster",
  "fr": "Découvrir WyneTaster",
  "de": "WyneTaster entdecken",
  "es": "Explorar WyneTaster",
  "it": "Esplora WyneTaster",
  "nl": "Ontdek WyneTaster",
  "pt": "Explorar WyneTaster"
},

"for wine producers.": {
  "en": "for wine producers.",
  "fr": "pour les producteurs de vin.",
  "de": "für Weinproduzenten.",
  "es": "para los productores de vino.",
  "it": "per i produttori di vino.",
  "nl": "voor wijnproducenten.",
  "pt": "para os produtores de vinho."
},

"Create your winery page, share your wines": {
  "en": "Create your winery page, share your wines",
  "fr": "Créez la page de votre domaine viticole, partagez vos vins",
  "de": "Erstellen Sie Ihre Weingutseite, präsentieren Sie Ihre Weine",
  "es": "Crea la página de tu bodega, comparte tus vinos",
  "it": "Crea la pagina della tua cantina, condividi i tuoi vini",
  "nl": "Maak je wijnhuispagina, deel je wijnen",
  "pt": "Crie a página da sua adega, partilhe os seus vinhos"
},

"and connect with wine lovers.": {
  "en": "and connect with wine lovers.",
  "fr": "et entrez en contact avec les amateurs de vin.",
  "de": "und vernetzen Sie sich mit Weinliebhabern.",
  "es": "y conecta con los amantes del vino.",
  "it": "e connettiti con gli amanti del vino.",
  "nl": "en kom in contact met wijnliefhebbers.",
  "pt": "e ligue-se aos amantes de vinho."
},

"Explore WyneMaker": {
  "en": "Explore WyneMaker",
  "fr": "Découvrir WyneMaker",
  "de": "WyneMaker entdecken",
  "es": "Explorar WyneMaker",
  "it": "Esplora WyneMaker",
  "nl": "Ontdek WyneMaker",
  "pt": "Explorar WyneMaker"
},

"explore wine regions.": {
  "en": "explore wine regions.",
  "fr": "explorez les régions viticoles.",
  "de": "Weinregionen entdecken.",
  "es": "explora las regiones vinícolas.",
  "it": "esplora le regioni vinicole.",
  "nl": "ontdek wijnregio's.",
  "pt": "explore as regiões vinícolas."
},

"Discover countries, regions and their signature wines.": {
  "en": "Discover countries, regions and their signature wines.",
  "fr": "Découvrez les pays, les régions et leurs vins emblématiques.",
  "de": "Entdecken Sie Länder, Regionen und ihre charakteristischen Weine.",
  "es": "Descubre países, regiones y sus vinos emblemáticos.",
  "it": "Scopri paesi, regioni e i loro vini simbolo.",
  "nl": "Ontdek landen, regio's en hun karakteristieke wijnen.",
  "pt": "Descubra países, regiões e os seus vinhos emblemáticos."
},

"A growing guide to the world of wine.": {
  "en": "A growing guide to the world of wine.",
  "fr": "Un guide en constante évolution sur le monde du vin.",
  "de": "Ein stetig wachsender Reiseführer durch die Welt des Weins.",
  "es": "Una guía en constante crecimiento sobre el mundo del vino.",
  "it": "Una guida in continua crescita al mondo del vino.",
  "nl": "Een steeds uitgebreidere gids voor de wereld van wijn.",
  "pt": "Um guia em constante expansão sobre o mundo do vinho."
},

"Explore WyneAtlas": {
  "en": "Explore WyneAtlas",
  "fr": "Découvrir WyneAtlas",
  "de": "WyneAtlas entdecken",
  "es": "Explorar WyneAtlas",
  "it": "Esplora WyneAtlas",
  "nl": "Ontdek WyneAtlas",
  "pt": "Explorar WyneAtlas"
},

"explore": {
  "en": "explore",
  "fr": "explorer",
  "de": "entdecken",
  "es": "explorar",
  "it": "esplora",
  "nl": "ontdek",
  "pt": "explorar"
},

"learn": {
  "en": "learn",
  "fr": "apprendre",
  "de": "lernen",
  "es": "aprender",
  "it": "impara",
  "nl": "leer",
  "pt": "aprender"
},

"taste": {
  "en": "taste",
  "fr": "déguster",
  "de": "verkosten",
  "es": "degustar",
  "it": "degusta",
  "nl": "proef",
  "pt": "provar"
},

"share": {
  "en": "share",
  "fr": "partager",
  "de": "teilen",
  "es": "compartir",
  "it": "condividi",
  "nl": "deel",
  "pt": "partilhar"
},

"funware for wine lovers developed and ©copyrighted by N'JOY Information Technology": {
  "en": "funware for wine lovers developed and © copyrighted by N'JOY Information Technology",
  "fr": "funware pour les amateurs de vin, développé par N'JOY Information Technology et protégé par le droit d'auteur ©",
  "de": "Funware für Weinliebhaber, entwickelt von N'JOY Information Technology und urheberrechtlich geschützt ©",
  "es": "funware para los amantes del vino, desarrollado por N'JOY Information Technology y protegido por derechos de autor ©",
  "it": "funware per gli amanti del vino, sviluppato da N'JOY Information Technology e protetto da copyright ©",
  "nl": "funware voor wijnliefhebbers, ontwikkeld door N'JOY Information Technology en auteursrechtelijk beschermd ©",
  "pt": "funware para os amantes do vinho, desenvolvido pela N'JOY Information Technology e protegido por direitos de autor ©"
}

}

export function translate_word(string, language) {
  let local_debug = false
  if (local_debug) console.log("original:", string)
  if (wordlist[string] && wordlist[string][language]) {
    if (local_debug) console.log("translation:", wordlist[string][language])
    return wordlist[string][language]
  } else {
    if (local_debug) console.log("translation:", string)
    return string
  }
}
